export default __webpack_public_path__ + "static/media/Hooden Box for Wheel Unit & Abrasive Reservoir.f010d65a.jpg";